export default __webpack_public_path__ + "static/media/Route Management.666b2979.svg";